export const Logo = ({ size = "sm", showTagline = false }) => {
  const big = size === "lg";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/brand/nia-icon.png"
        alt="Nia Ecoversity emblem: village, hibiscus, leaves and roots"
        className={big ? "h-28 w-auto sm:h-36" : "h-12 w-auto"}
      />
      <div className="leading-none">
        <div className={`font-serif font-semibold text-plum ${big ? "text-6xl sm:text-7xl" : "text-3xl"}`}>Nia</div>
        <div className={`font-serif font-medium text-leaf ${big ? "text-3xl sm:text-4xl mt-1" : "text-lg -mt-0.5"}`}>Ecoversity</div>
        {showTagline && (
          <>
            <div className="mt-3 flex items-center gap-2" aria-hidden="true">
              <span className="h-px w-16 bg-gold" />
              <span className="h-1.5 w-1.5 rounded-sm bg-primary" />
              <span className="h-px w-16 bg-gold" />
            </div>
            <p className="mt-2 max-w-[16rem] text-xs tracking-wide text-foreground/70">
              An ecology for lifelong learning, healing, becoming and contribution
            </p>
          </>
        )}
      </div>
    </div>
  );
};
